import { z } from 'zod';
import { uuidSchema, strokeInputSchema, createWhiteboardPageSchema, cursorInputSchema, chatMessageInputSchema } from '@tutor/validation';

// src/events.ts
var ClientEvent = {
  CLASSROOM_JOIN: "classroom:join",
  CLASSROOM_LEAVE: "classroom:leave",
  CLASSROOM_END: "classroom:end",
  WHITEBOARD_STROKE: "whiteboard:stroke",
  WHITEBOARD_STROKE_PREVIEW: "whiteboard:stroke-preview",
  WHITEBOARD_UNDO: "whiteboard:undo",
  WHITEBOARD_CLEAR_PAGE: "whiteboard:clear-page",
  WHITEBOARD_ADD_PAGE: "whiteboard:add-page",
  WHITEBOARD_SET_ACTIVE_PAGE: "whiteboard:set-active-page",
  WHITEBOARD_CURSOR: "whiteboard:cursor",
  WHITEBOARD_REQUEST_SYNC: "whiteboard:request-sync",
  CHAT_SEND: "chat:send",
  CHAT_TYPING: "chat:typing",
  MEDIA_STATE: "media:state",
  RTC_SIGNAL: "rtc:signal",
  RTC_READY: "rtc:ready"
};
var ServerEvent = {
  CLASSROOM_STATE: "classroom:state",
  CLASSROOM_PARTICIPANT_JOINED: "classroom:participant-joined",
  CLASSROOM_PARTICIPANT_LEFT: "classroom:participant-left",
  CLASSROOM_ENDED: "classroom:ended",
  WHITEBOARD_STROKE: "whiteboard:stroke",
  WHITEBOARD_STROKE_PREVIEW: "whiteboard:stroke-preview",
  WHITEBOARD_STROKE_REMOVED: "whiteboard:stroke-removed",
  WHITEBOARD_PAGE_CLEARED: "whiteboard:page-cleared",
  WHITEBOARD_PAGE_ADDED: "whiteboard:page-added",
  WHITEBOARD_ACTIVE_PAGE: "whiteboard:active-page",
  WHITEBOARD_CURSOR: "whiteboard:cursor",
  WHITEBOARD_SYNC: "whiteboard:sync",
  CHAT_MESSAGE: "chat:message",
  CHAT_TYPING: "chat:typing",
  MEDIA_STATE: "media:state",
  RTC_SIGNAL: "rtc:signal",
  RTC_PEER_READY: "rtc:peer-ready",
  ERROR: "classroom:error"
};
function classroomRoom(lessonId) {
  return `lesson:${lessonId}`;
}
function userRoom(userId) {
  return `user:${userId}`;
}
var joinClassroomPayloadSchema = z.object({
  lessonId: uuidSchema
});
var strokePayloadSchema = z.object({
  lessonId: uuidSchema,
  stroke: strokeInputSchema
});
var strokePreviewPayloadSchema = z.object({
  lessonId: uuidSchema,
  pageId: uuidSchema,
  strokeId: uuidSchema,
  tool: strokeInputSchema.shape.tool,
  colour: strokeInputSchema.shape.colour,
  width: strokeInputSchema.shape.width,
  points: strokeInputSchema.shape.points
});
var undoPayloadSchema = z.object({
  lessonId: uuidSchema,
  pageId: uuidSchema
});
var clearPagePayloadSchema = undoPayloadSchema;
var addPagePayloadSchema = createWhiteboardPageSchema.extend({
  lessonId: uuidSchema
});
var setActivePagePayloadSchema = z.object({
  lessonId: uuidSchema,
  pageId: uuidSchema
});
var cursorPayloadSchema = cursorInputSchema.extend({
  lessonId: uuidSchema
});
var chatSendPayloadSchema = chatMessageInputSchema.extend({
  lessonId: uuidSchema
});
var typingPayloadSchema = z.object({
  lessonId: uuidSchema,
  isTyping: z.boolean()
});
var mediaStatePayloadSchema = z.object({
  lessonId: uuidSchema,
  audioEnabled: z.boolean(),
  videoEnabled: z.boolean(),
  screenSharing: z.boolean()
});
var rtcSignalPayloadSchema = z.object({
  lessonId: uuidSchema,
  targetUserId: uuidSchema,
  signal: z.object({
    kind: z.enum(["offer", "answer", "candidate", "renegotiate"]),
    /** Passed through untouched — the server never parses SDP. */
    description: z.unknown().optional(),
    candidate: z.unknown().optional()
  })
});
var rtcReadyPayloadSchema = z.object({
  lessonId: uuidSchema
});
var requestSyncPayloadSchema = z.object({
  lessonId: uuidSchema
});

export { ClientEvent, ServerEvent, addPagePayloadSchema, chatSendPayloadSchema, classroomRoom, clearPagePayloadSchema, cursorPayloadSchema, joinClassroomPayloadSchema, mediaStatePayloadSchema, requestSyncPayloadSchema, rtcReadyPayloadSchema, rtcSignalPayloadSchema, setActivePagePayloadSchema, strokePayloadSchema, strokePreviewPayloadSchema, typingPayloadSchema, undoPayloadSchema, userRoom };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map